import { TIMEZONE_ARRAY } from '_constants';
import { getTimezoneName } from 'utils/custom';

const getTimezoneTitle = timezone => TIMEZONE_ARRAY
  .find(({ timezoneName }) => getTimezoneName(timezone) === timezoneName).timezoneTitle;

export default getTimezoneTitle;
